import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

import { useAIParserSession } from "./use-ai-parser-session"

type Data = {
  sessionId: string
  columnId: string
}

function deleteColumn(data: Data) {
  const { sessionId, columnId } = data

  return api.delete(`/parser/delete-column?session_id=${sessionId}&column_id=${columnId}`)
}

export function useDeleteColumnMutation() {
  const queryClient = useQueryClient()
  const { currentSessionId } = useAIParserSession()

  return useMutation({
    mutationFn: (columnId: string) => {
      if (!currentSessionId) {
        throw new Error("No session id")
      }
      return deleteColumn({ sessionId: currentSessionId, columnId })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.fullSession(currentSessionId ?? ""),
      })
    },
  })
}
